import React from "react"
import {InputField, InputProps} from "../../input/input-field"
import {FormField} from "../form-field/form-field"

export interface FormTextInputProps extends InputProps {
  readonly hideEmptyValueValidity?: boolean
  readonly label: string
}

export const FormTextInput: React.FC<FormTextInputProps> = (
  {
    label,
    type,
    value,
    hideEmptyValueValidity = false,
    disabled = false,
    readOnly = false,
    showValidity = false,
    validationResult,
    onChange,
    onBlur,
    testId,
    forwardRef
  }) => {

  const actualShowValidity = hideEmptyValueValidity ? showValidity && value?.trim().length > 0 : showValidity

  return <FormField label={label} showValidity={showValidity} validationResult={validationResult}>
    <InputField type={type}
                value={value}
                disabled={disabled}
                readOnly={readOnly}
                showValidity={actualShowValidity}
                validationResult={validationResult}
                onChange={onChange}
                onBlur={onBlur}
                testId={testId}
                forwardRef={forwardRef}/>
  </FormField>
}
